import { writable, get } from 'svelte/store';
export const roomStore = writable(null);
export function setRoom(id, type, audioEnabled) {
    roomStore.set({ id, type, audioEnabled });
}
export function getRoom() {
    return get(roomStore);
}
export function clearRoom() {
    roomStore.set(null);
}
